(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3904],{

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 55515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useMyOrderPreferences; }
/* harmony export */ });
/* unused harmony export getMyOrderPreferencesQuery */
/* harmony import */ var _data_fragments_preferences_appOrderPreferences__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82339);
/* harmony import */ var _data_fragments_preferences_storePreferencesFragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54654);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getMyOrderPreferences($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      ...appOrderPreferences\n      storeWithSlots: store {\n        ...storePreferences\n        schedule {\n          itsOpenNow: itsAvailableAt(websiteId: $websiteId, shouldAddMessage: true)\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getMyOrderPreferencesQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject(), _data_fragments_preferences_appOrderPreferences__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, _data_fragments_preferences_storePreferencesFragment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var useMyOrderPreferences = function(websiteId) {
    return (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useApolloQuery */ .Zu)({
        query: getMyOrderPreferencesQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() || !websiteId,
        partial: true
    });
};


/***/ }),

/***/ 49343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsStore; }
});

;// CONCATENATED MODULE: ./src/helpers/websites/isStore.ts
function isStore(businessType) {
    return businessType === "store";
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/misc/WebsiteBusinessTypeContext.ts

/* harmony default export */ var WebsiteBusinessTypeContext = (react.createContext(null));

// EXTERNAL MODULE: ./src/helpers/websites/getDomain.ts
var getDomain = __webpack_require__(15141);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteBusinessType.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteBusinessTypeFromDomain_cached($domain: String) {\n        website(domain: $domain) {\n          _id\n          businessType\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useWebsiteBusinessType() {
    var businessType = (0,react.useContext)(WebsiteBusinessTypeContext);
    var website = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            domain: (0,getDomain/* default */.Z)()
        },
        fetchPolicy: "cache-first",
        omit: (0,isServerSide/* default */.Z)(),
        partial: true
    }).website;
    if (businessType) return businessType;
    if (!website || !(0,getDomain/* default */.Z)()) return null;
    return website.businessType;
};

;// CONCATENATED MODULE: ./src/hooks/useIsStore.ts


function useIsStore(website) {
    var businessType = useWebsiteBusinessType();
    if (website === null || website === void 0 ? void 0 : website.businessType) {
        businessType = website.businessType;
    }
    return isStore(businessType);
};


/***/ }),

/***/ 86288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMyOrderPreferencesWithDefault; }
/* harmony export */ });
/* harmony import */ var _data_queries_preferences_getMyOrderPreferences__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55515);

/**
 * NOTE: This must be SSR Compatible (i.e. it must not suspend nor return user data)
 */ function useMyOrderPreferencesWithDefault(website) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        queryStoreAvailabilityFromSlots: true
    };
    var ref = (0,_data_queries_preferences_getMyOrderPreferences__WEBPACK_IMPORTED_MODULE_0__/* .useMyOrderPreferences */ .n)(website._id), queriedPrefs = ref.preferences, networkStatus = ref.networkStatus;
    var preferences = queriedPrefs ? queriedPrefs : {
        menuId: website.defaultMenuId
    };
    return {
        preferences: preferences,
        loading: networkStatus <= 2 || !website
    };
};


/***/ }),

/***/ 73904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DefaultLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ClientSuspense__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88385);
/* harmony import */ var _components_SafeSuspense__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5822);
/* harmony import */ var _components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75288);
/* harmony import */ var _components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53762);
/* harmony import */ var _helpers_misc_isIFrame__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29453);
/* harmony import */ var _hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5455);
/* harmony import */ var _hooks_useIsStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49343);
/* harmony import */ var _hooks_useMyOrderPreferencesWithDefault__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86288);
/* harmony import */ var _hooks_useWebsiteLayout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18368);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62832);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_11__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













function DefaultLayout(props) {
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().website;
    var ref = (0,_hooks_useMyOrderPreferencesWithDefault__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(website), preferences = ref.preferences, loading = ref.loading;
    var layout = (0,_hooks_useWebsiteLayout__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(website);
    var isStore = (0,_hooks_useIsStore__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(website);
    var specialLayout = (0,_hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var Navbar = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isStore && layout.headerLayout === "cpg" ? next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(1384), __webpack_require__.e(893), __webpack_require__.e(8761), __webpack_require__.e(615), __webpack_require__.e(3596), __webpack_require__.e(8354), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(602), __webpack_require__.e(1038), __webpack_require__.e(3032), __webpack_require__.e(8316), __webpack_require__.e(8106), __webpack_require__.e(3089), __webpack_require__.e(8957), __webpack_require__.e(3154), __webpack_require__.e(6452), __webpack_require__.e(8663)]).then(__webpack_require__.bind(__webpack_require__, 19405));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(19405)
                    ];
                }
            }
        }) : next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(6907), __webpack_require__.e(791), __webpack_require__.e(8354), __webpack_require__.e(6452), __webpack_require__.e(681)]).then(__webpack_require__.bind(__webpack_require__, 26353));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(26353)
                    ];
                }
            }
        });
    }, [
        isStore,
        layout === null || layout === void 0 ? void 0 : layout.headerLayout
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            _helpers_misc_isIFrame__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z || specialLayout === "chat" ? null : isStore && layout.headerLayout === "cpg" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ClientSuspense__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {
                    website: _objectSpread({}, website),
                    layout: layout,
                    userPreferences: _objectSpread({}, preferences),
                    loading: loading
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspense__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {
                    website: _objectSpread({}, website),
                    userPreferences: _objectSpread({}, preferences)
                })
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ })

}]);